import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCursorDefault = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 22,
	viewBox: "0 0 16 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group",
		filter: "url(#filter0_d_687_13345)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "arrow border",
			d: "M10.9231 16.0296C11.0985 16.4505 10.9299 18.0447 10 18.4142C9.07008 18.7837 7.88197 18.4142 7.88197 18.4142L5.72605 14.1024L2 17.8284V1L13.4142 12.4142H9.16151C9.37022 12.8144 10.7003 15.4948 10.9231 16.0296Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			id: "arrow",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 3.41422V15.4142L6 12.4142L8.5 17.4142C8.5 17.4142 9.17631 17.63 9.5 17.4142C9.82369 17.1984 10.1457 16.7638 10 16.4142C9.31233 14.7638 7.5 11.4142 7.5 11.4142H11L3 3.41422Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_687_13345",
		x: .2,
		y: .2,
		width: 15.0141,
		height: 21.1784,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .9 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_687_13345"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_687_13345",
				result: "shape"
			})
		]
	}) })]
});
export default SvgCursorDefault;
